import { render, staticRenderFns } from "./JobPreviewHeader.vue?vue&type=template&id=7896ed20&scoped=true"
import script from "./JobPreviewHeader.vue?vue&type=script&lang=js"
export * from "./JobPreviewHeader.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewHeader.vue?vue&type=style&index=0&id=7896ed20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896ed20",
  null
  
)

export default component.exports